"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BrandsLanguageListCtl = /** @class */ (function (_super) {
    __extends(BrandsLanguageListCtl, _super);
    function BrandsLanguageListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_app_language_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_id; });
        _this.dk_app_language_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_title; });
        _this.dk_is_default = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_default; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    BrandsLanguageListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    BrandsLanguageListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    BrandsLanguageListCtl.prototype.LoadData = function (brandId, onDone) {
        var _this = this;
        webAApi_1.ListBrandAppLanguagesByBrandIdGet.exec({ brand_id: brandId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    app_language_id: resp.list[i].app_language_id,
                    app_language_title: resp.list[i].app_language_title,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    is_default: resp.list[i].is_default
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsLanguageListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandAppLanguage.exec({
            data: {
                app_language_id: data.app_language_id,
                brand_id: data.brand_id,
                is_default: data.is_default
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                app_language_id: data.app_language_id,
                app_language_title: resp.app_language_title,
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                is_default: data.is_default
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    /* public EditData(data: IEditAppLanguageItem, onDone?: () => void) {
 
         let _tmp = this.getById(data.key);
         if (_tmp) {
 
             DoEditBrandAppLanguage.exec({
 
                 data: {
 
                     brands_app_language_id: data.key,
                     app_language_id: data.app_language_id,
                     is_default: data.is_default
                 }
 
             }, (resp) => {
 
                 _tmp.app_language_id = data.app_language_id;
                 _tmp.app_language_title = resp.app_language_title;
                 _tmp.is_default = data.is_default;
                 _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
 
                 this.Update();
                 if (onDone) {
                     onDone();
                 }
 
             }, (err) => {
                 this._errDialog.ShowApiError(err);
             });
         }
 
     }*/
    BrandsLanguageListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BrandsLanguageListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBrandAppLanguage.exec({
                data: {
                    brands_app_language_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsLanguageListCtl.prototype.DoSetIsDefault = function (key, isDefault, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBrandAppLanguageIsDefault.exec({ data: { brands_app_language_id: key, is_default: isDefault } }, function (resp) {
                _tmp.is_default = isDefault;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BrandsLanguageListCtl;
}(BaseController_1.BaseController));
exports.BrandsLanguageListCtl = BrandsLanguageListCtl;
/*export interface IEditAppLanguageItem {

    key: number;

    app_language_id: number;

    is_default: boolean;

}*/ 



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ctl/options/BrandsLanguagesListCtl.ts
// module id = 945
// module chunks = 0